export default __webpack_public_path__ + "static/media/hamburger.9f42ebf5.svg";